export default __webpack_public_path__ + "static/samsungFutureInsight-ac2b7ca9f6209d750bcd3fa0003d9d5c.png";